/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldprice2Inputs */

const en_ticketsfieldprice2 = /** @type {(inputs: Ticketsfieldprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price in euros`)
};

const de_ticketsfieldprice2 = /** @type {(inputs: Ticketsfieldprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis in Euro`)
};

/**
* | output |
* | --- |
* | "Price in euros" |
*
* @param {Ticketsfieldprice2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldprice2 = /** @type {((inputs?: Ticketsfieldprice2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldprice2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldprice2(inputs)
	return de_ticketsfieldprice2(inputs)
});
export { ticketsfieldprice2 as "ticketsFieldPrice" }